<div class="asecurity-accounts-map_complex-table" [table]="table">
  <div class="asecurity-accounts-map_table-header-wrapper">
    <table class="asecurity-accounts-map_table">
      <thead>
        <tr tableHeaderRow>
          <th textHiding *tableColumn="table.columnsDict.SYMBOL; let column" class="asecurity-accounts-map_table_header -symbol"
            [tooltipL10n]="column.label">
            <span>{{column.label | l10n}}</span>
          </th>
          <th *tableColumn="table.columnsDict.FLAGS; let column" class="asecurity-accounts-map_table_header -flags"></th>
          <th textHiding *tableColumn="table.columnsDict.SIDE; let column" class="asecurity-accounts-map_table_header -side"
            [tooltipL10n]="column.label">
            <span>{{column.label | l10n}}</span>
          </th>
          <th textHiding *tableColumn="table.columnsDict.QTY; let column" class="asecurity-accounts-map_table_header -number"
            [tooltipL10n]="column.label">
            <span>{{column.label | l10n}}</span>
          </th>
          <th textHiding *tableColumn="table.columnsDict.PRICE_RATIO; let column" class="asecurity-accounts-map_table_header -number"
            [tooltipL10n]="column.label">
            <span>{{column.label | l10n}}</span>
          </th>
          <th textHiding *tableColumn="table.columnsDict.ACCOUNT; let column" class="asecurity-accounts-map_table_header -account"
            [tooltipL10n]="column.label">
            <span>{{column.label | l10n}}</span>
          </th>
          <th textHiding *tableColumn="table.columnsDict.LEVERAGE; let column" class="asecurity-accounts-map_table_header -leverage"
            [tooltipL10n]="column.label">
            <span>{{column.label | l10n}}</span>
          </th>
        </tr>
      </thead>
    </table>
  </div>
  <div class="asecurity-accounts-map_table-body-wrapper" elementRuler>
    <table class="asecurity-accounts-map_table">
      <tbody>
        <tr *tableBodyRow="let row of table.rows"
          class="asecurity-accounts-map_table_row">

          <td *tableColumn class="asecurity-accounts-map_table_cell -symbol"
            textHiding tooltip #symbolTooltip="tooltip">
            <display-symbol [security]="row.securityKey" [tooltipDirective]="symbolTooltip"></display-symbol>
          </td>
          <td *tableColumn class="asecurity-accounts-map_table_cell -flags"
            textHiding>
            <span>
              @if (row.leg.activeQuoting) {
                <span class="-flag" tooltipL10n="components.asecurity-accounts-map.active_quoting">Q</span>
              }
              @if (row.isMakerOnly) {
                <span class="-flag" tooltipL10n="components.asecurity-accounts-map.maker_only">M</span>
              }
            </span>
          </td>
          <td *tableColumn class="asecurity-accounts-map_table_cell -side"
            textHiding [tooltipL10n]="row.displaySide.label">
            <span class="-side {{row.displaySide.classes}}">{{row.displaySide.label | l10n}}</span>
          </td>
          <td *tableColumn class="asecurity-accounts-map_table_cell -number"
            textHiding tooltip #qtyTooltip="tooltip">
            <span [displayDecimal]="row.qty" [dashIfEmpty]="true" [formatter]="row.qtyFormatter" [tooltipDirective]="qtyTooltip"></span>
          </td>
          <td *tableColumn class="asecurity-accounts-map_table_cell -number"
            textHiding tooltip #priceRatioTooltip="tooltip">
            <span [displayDecimal]="row.displayPriceRatio" [dashIfEmpty]="true" [tooltipDirective]="priceRatioTooltip"></span>
          </td>
          <td *tableColumn class="asecurity-accounts-map_table_cell -account"
            textHiding [tooltip]="row.displayAccountName">
            @if (row.accountControl.enabled) {
              <account-base-autocomplete
                [class.-submitted]="!isDisabled"
                [formControl]="row.accountControl"
                [accountFilter]="row.accountFilter"
                [supportSplitAccounts]="true">
              </account-base-autocomplete>
            } @else {
              <span>{{row.displayAccountName}}</span>
            }
            <ng-template #readonlyAccountTpl>
              <span>{{row.displayAccountName}}</span>
            </ng-template>
          </td>
          <td *tableColumn class="asecurity-accounts-map_table_cell -leverage"
            textHiding [tooltip]="row.leverageControl.value">
            @if (row.isLeverageAllowed) {
              @if (row.leverageControl.enabled) {
                <leverage-select
                  [class.-submitted]="!isDisabled"
                  [formControl]="row.leverageControl"
                  [securityKey]="row.securityKey"
                  [accountBase]="row.accountControl.value"
                  [side]="row.displaySide.resultSide">
                </leverage-select>
              } @else {
                <span>{{row.leverageControl.value}}</span>
              }
              <ng-template #readonlyLeverageTpl>
                <span>{{row.leverageControl.value}}</span>
              </ng-template>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Elements to display in Trade Form Block and Order Form Block. Classes are the same as in that components. -->
<ng-template #externalMaxShowTpl>
  <div class="form-block_column -max-show">
    <label for="maxShow_{{id}}" class="form-block_label"
      textHiding
      tooltip="{{'components.asecurity-accounts-map.iceberg_field_prefix' | l10n}} {{'components.asecurity-accounts-map.max_show' | l10n}}">
      <span>{{'components.asecurity-accounts-map.iceberg_field_prefix' | l10n}} {{'components.asecurity-accounts-map.max_show' | l10n}}</span>
    </label>
    @if (externalIcebergFieldsInfo?.maxUnfilled.formControl.enabled) {
      <decimal-input-wrapper
        [currency]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxShow.currency)">
        <input class="form-block_value" type="text"
          [min]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxShow.qtyInputParams?.min)"
          [max]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxShow.qtyInputParams?.max)"
          [step]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxShow.qtyInputParams?.step)"
          [decimal]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxShow.qtyInputParams?.decimalCount)"
          [precision]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxShow.qtyInputParams?.precision)"
          [formControl]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxShow.formControl)"
          [allowEmpty]="true"
          decimalInput
          id="maxShow_{{id}}"
          />
      </decimal-input-wrapper>
    } @else {
      <div class="form-block_value -static" textHiding tooltip #maxShowTooltipEl="tooltip">
        <span
          [displayDecimal]="externalIcebergFieldsInfo?.maxShow.formControl.value"
          [formatter]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxShow.qtyFormatter)"
          [dashIfEmpty]="true"
          [tooltipDirective]="maxShowTooltipEl">
        </span>
      </div>
    }
    <ng-template #maxShowReadonlyTpl>
      <div class="form-block_value -static" textHiding tooltip #maxShowTooltipEl="tooltip">
        <span
          [displayDecimal]="externalIcebergFieldsInfo?.maxShow.formControl.value"
          [formatter]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxShow.qtyFormatter)"
          [dashIfEmpty]="true"
          [tooltipDirective]="maxShowTooltipEl">
        </span>
      </div>
    </ng-template>
  </div>
</ng-template>
<ng-template #externalMaxUnfilledTpl>
  <div class="form-block_column -max-unfilled">
    <label for="maxUnfilled_{{id}}" class="form-block_label"
      textHiding
      tooltip="{{'components.asecurity-accounts-map.iceberg_field_prefix' | l10n}} {{'components.asecurity-accounts-map.max_unfilled' | l10n}}">
      <span>{{'components.asecurity-accounts-map.iceberg_field_prefix' | l10n}} {{'components.asecurity-accounts-map.max_unfilled' | l10n}}</span>
    </label>
    @if (externalIcebergFieldsInfo?.maxUnfilled.formControl.enabled) {
      <decimal-input-wrapper
        [currency]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxUnfilled.currency)">
        <input class="form-block_value" type="text"
          [min]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxUnfilled.qtyInputParams?.min)"
          [max]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxUnfilled.qtyInputParams?.max)"
          [step]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxUnfilled.qtyInputParams?.step)"
          [decimal]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxUnfilled.qtyInputParams?.decimalCount)"
          [precision]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxUnfilled.qtyInputParams?.precision)"
          [formControl]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxUnfilled.formControl)"
          [allowEmpty]="true"
          decimalInput
          id="maxUnfilled_{{id}}"
          />
      </decimal-input-wrapper>
    } @else {
      <div class="form-block_value -static" textHiding tooltip #maxUnfilledTooltipEl="tooltip">
        <span
          [displayDecimal]="externalIcebergFieldsInfo?.maxUnfilled.formControl.value"
          [formatter]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxUnfilled.qtyFormatter)"
          [dashIfEmpty]="true"
          [tooltipDirective]="maxUnfilledTooltipEl">
        </span>
      </div>
    }
    <ng-template #maxUnfilledReadonlyTpl>
      <div class="form-block_value -static" textHiding tooltip #maxUnfilledTooltipEl="tooltip">
        <span
          [displayDecimal]="externalIcebergFieldsInfo?.maxUnfilled.formControl.value"
          [formatter]="$safeNavigationMigration(externalIcebergFieldsInfo?.maxUnfilled.qtyFormatter)"
          [dashIfEmpty]="true"
          [tooltipDirective]="maxUnfilledTooltipEl">
        </span>
      </div>
    </ng-template>
  </div>
</ng-template>
